import React from 'react';
import moment from 'moment';
import { createLabRequest, updateLabRequest } from 'services/lab_request/labRequest';
import createPatientInfo from 'services/lab_request/patient';
import { LOGGEDIN_USER_DATA } from 'global_config/constant-global';
import PageTitle from 'shared_components/page_title';
import { moduleTitles, requestTypes } from 'modules/main/settings/lab_exam_request/settings';
import Restriction from 'modules/main/lab_request/steps/lr_restriction/restriction';
import Tracker from 'modules/main/lab_request/tracker';
import {
	LR_SEL_EXAMS,
	LR_DEL_PANELS,
	LR_OTHER_INFO,
	LR_PERSONAL_INFO,
	LR_REQUEST_TYPE,
	LR_EDIT_SEL_EXAM_REF,
} from 'modules/main/lab_request/steps/constants';
import SummarySection from './section';
import SummaryTable from './table';
import SummaryFooter from './footer';
import { Form } from 'antd';

class SummaryStep extends React.Component {
	state = {
		exams: [],
		otherInfo: {},
		personalInfo: {},
		user: {},
	};

	constructor(props) {
		super(props);
		this.formRef = React.createRef();

		// 4 is the stepnumber
		this.restriction = new Restriction(4);
	}

	async componentDidMount() {
		const exams = JSON.parse(sessionStorage.getItem(LR_SEL_EXAMS));
		const otherInfo = JSON.parse(sessionStorage.getItem(LR_OTHER_INFO));
		const personalInfo = JSON.parse(sessionStorage.getItem(LR_PERSONAL_INFO));
		const user = JSON.parse(sessionStorage.getItem(LOGGEDIN_USER_DATA));
		const examRef = JSON.parse(sessionStorage.getItem(LR_EDIT_SEL_EXAM_REF));
		// const cancelledPanels = JSON.parse(sessionStorage.getItem(LR_DEL_PANELS));
		// this.setState({ exams, user, otherInfo, examRef, cancelledPanels});

		this.setState({ exams, user, otherInfo, examRef, personalInfo });
	}

	saveForCreate = async () => {
		const { otherInfo, exams, user, personalInfo } = this.state;
		const sessUser = JSON.parse(sessionStorage.getItem(LOGGEDIN_USER_DATA));

		if (otherInfo.patientID === undefined) {
			const createdPatient = await createPatientInfo({
				userID: sessUser.userID,
				...personalInfo,
				addressCode: personalInfo.town,
			});

			// If createPatient has an error, stop the function
			if (!createdPatient) return;

			otherInfo.patientID = createdPatient.patientID;

			const payloadExams = exams.map(exam => ({
				panelID: exam.selectedPanel ? exam.selectedPanel.panelID : 0,
				examID: exam.examID,

				priority: exam.examRequestAutoSTAT,
				sendOut: exam.examRequestAutoSendOut,
			}));

			const payload = {
				...otherInfo,
				userID: user.userID,
				hospitalRequestID: otherInfo.hospitalID,
				exams: payloadExams,
			};

			return createLabRequest(payload);
		} else {
			// otherInfo.patientID = createdPatient.patientID;

			const payloadExams = exams.map(exam => ({
				panelID: exam.selectedPanel ? exam.selectedPanel.panelID : 0,
				examID: exam.examID,

				priority: exam.examRequestAutoSTAT,
				sendOut: exam.examRequestAutoSendOut,
			}));

			const payload = {
				...otherInfo,
				userID: user.userID,
				hospitalRequestID: otherInfo.hospitalID,
				exams: payloadExams,
			};

			return createLabRequest(payload);
		}
	};

	saveForEdit = async () => {
		const { otherInfo, user, exams, examRef } = this.state;
		const { hospitalID, ...restOtherInfo } = otherInfo;

		// const newExams = [];
		// const examRefIDs = examRef.map(item => item.examID);

		// exams.forEach(x => {
		// 	if(examRefIDs.includes(x.examID) === false)
		// 		newExams.push({
		// 			sectionID: x.selectedSection.sectionID,
		// 			sampleID: x.selectedSpecimen ? x.selectedSpecimen.specimenID : '',
		// 			specimenID: x.selectedSpecimen ? x.selectedSpecimen.specimenID : '',
		// 			sampleSpecimenID: x.sampleSpecimenID ? x.selectedSpecimen.specimenID : '',
		// 			panelID: x.selectedPanel ? x.selectedPanel.panelID : null,
		// 			examID: x.examID,
		// 			priority: ''
		// 		});
		// });

		try {
			const values = await this.formRef.current.validateFields();
			console.log('Form Values:', values);

			const newExams = exams.map(x => ({
				sectionID: x.selectedSection.sectionID,
				specimenID: x.selectedSpecimen ? x.selectedSpecimen.specimenID : '',
				sampleSpecimenID: x.sampleSpecimenID ? x.sampleSpecimenID : '',
				panelID: x.selectedPanel ? x.selectedPanel.panelID : null,
				examID: x.examID,
				priority: x.examRequestAutoSTAT,
				sendOut: x.examRequestAutoSendOut,
			}));

			const removedExams = examRef.reduce((accumulator, previewExam) => {
				const isSelected = exams.some(
					selectedExam =>
						selectedExam.examID === previewExam.examID &&
						selectedExam.selectedSection.sectionID === previewExam.selectedSection.sectionID &&
						selectedExam.selectedSpecimen.specimenID === previewExam.selectedSpecimen.specimenID,
				);

				if (!isSelected) {
					const key = `${previewExam.selectedSection.sectionID}-${previewExam.selectedSpecimen.specimenID}`;
					const reason = values.reasons ? values.reasons[key] : '';

					accumulator.push({
						sectionID: previewExam.selectedSection.sectionID,
						specimenID: previewExam.selectedSpecimen.specimenID || '',
						sampleSpecimenID: previewExam.sampleSpecimenID || '',
						panelID: previewExam.selectedPanel ? previewExam.selectedPanel.panelID : null,
						examID: previewExam.examID,
						cancelReason: reason || '',
						priority: previewExam.examRequestAutoSTAT,
						// sendOut: previewExam.examRequestAutoSendOut,
					});
				}

				return accumulator;
			}, []);

			const payload = {
				...restOtherInfo,
				requestDateTime: moment().format('yyyy-MM-DD hh:mm:ss'),
				hospitalRequestID: hospitalID,
				userID: user.userID,
				exams: newExams,
				remove: removedExams,
				physicianID: otherInfo.physicianID || 0,
			};

			console.log('Payload:', payload);
			const response = await updateLabRequest(payload);
			console.log('Update Response:', response);

			return response;
		} catch (errorInfo) {
			console.log('Validate Failed:', errorInfo);
		}
	};

	render() {
		const { exams } = this.state;
		const { restriction } = this;
		const moduleTitle =
			sessionStorage.getItem(LR_REQUEST_TYPE) === requestTypes.create
				? moduleTitles.create
				: moduleTitles.edit;
		if (restriction.hasAccess) {
			return (
				<div>
					<PageTitle pageTitle={moduleTitle} />
					<Tracker active={3} />
					<SummarySection />
					<Form ref={this.formRef}>
						<SummaryTable exams={exams} />
					</Form>
					<br />
					<SummaryFooter saveForCreate={this.saveForCreate} saveForEdit={this.saveForEdit} />
				</div>
			);
		}

		return restriction.redirect();
	}
}

export default SummaryStep;
